<router-outlet></router-outlet>
<frontend-app-loading *ngIf="isLoading$ | async"></frontend-app-loading>
<frontend-account-disable *ngIf="disableAccount$ | async"></frontend-account-disable>
